/**
 * GPU 한도 요청 탭의 조회 축. URL 이 소유한다(rules.md §17). 그래서 새로고침과 딥링크에서도
 * 유지되고 `?tab=requests` 와 함께 공유된다. 두 축 모두 2값이므로 Field+Switch 로 표시한다.
 */
export type GpuQuotaRequestFilterState = {
  // 켜면 운영자 대기열(pending)만 조회한다. 기본값은 전체 이력이다.
  pendingOnly: boolean;
  // 켜면 내가 접수한 요청만 조회한다. 기준은 선점자가 아니라 행에 기록된 접수자(requested_by)다.
  mineOnly: boolean;
};

export const EMPTY_GPU_QUOTA_REQUEST_FILTERS: GpuQuotaRequestFilterState = {
  pendingOnly: false,
  mineOnly: false,
};

const PARAM = { pending: "pending", mine: "mine" } as const;
const ON = "1";

export function readGpuQuotaRequestFilters(params: URLSearchParams): GpuQuotaRequestFilterState {
  return {
    pendingOnly: params.get(PARAM.pending) === ON,
    mineOnly: params.get(PARAM.mine) === ON,
  };
}

// 자기 키만 지우고 다시 쓴다. 입력은 변경하지 않는다.
export function writeGpuQuotaRequestFilters(
  params: URLSearchParams,
  state: GpuQuotaRequestFilterState,
): URLSearchParams {
  const next = new URLSearchParams(params);
  for (const [key, on] of [
    [PARAM.pending, state.pendingOnly],
    [PARAM.mine, state.mineOnly],
  ] as const) {
    if (on) {
      next.set(key, ON);
    } else {
      next.delete(key);
    }
  }
  return next;
}

export type GpuQuotaRequestFilterChip = {
  axis: keyof GpuQuotaRequestFilterState;
  label: string;
};

export function gpuQuotaRequestFilterChips(
  state: GpuQuotaRequestFilterState,
): GpuQuotaRequestFilterChip[] {
  const chips: GpuQuotaRequestFilterChip[] = [];
  if (state.pendingOnly) {
    chips.push({ axis: "pendingOnly", label: "대기만" });
  }
  if (state.mineOnly) {
    chips.push({ axis: "mineOnly", label: "내 요청만" });
  }
  return chips;
}
